/** Estados que "ocupan" cupo mientras la invitacion esta en circulacion. */
const ESTADOS_EN_CIRCULACION = new Set([
    'disponible',
    'en_mano',
    'entregada',
    'registrada',
]);
/**
 * Calcula los cuatro numeros del tablero sobre el snapshot completo de
 * invitaciones. Ver plan §4. Se corre en el cliente; no hace falta
 * agregacion en servidor para 300-500 documentos.
 */
export function calcularAforo(invitaciones, aforoObjetivo) {
    let comprometido = 0;
    let confirmado = 0;
    let presentes = 0;
    for (const inv of invitaciones) {
        if (inv.estado === 'anulada')
            continue;
        if (ESTADOS_EN_CIRCULACION.has(inv.estado)) {
            comprometido += inv.cupo;
        }
        if (inv.estado === 'registrada') {
            // Personas realmente registradas: titular siempre; acompanante si lo hay.
            confirmado += 1 + (inv.invitado.acompanante ? 1 : 0);
        }
        if (inv.asistencia.titular.presente)
            presentes += 1;
        if (inv.asistencia.acompanante.presente)
            presentes += 1;
    }
    return {
        comprometido,
        confirmado,
        presentes,
        disponible: aforoObjetivo - comprometido,
    };
}
//# sourceMappingURL=aforo.js.map